// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4037) return "static/chunks/4037.f52d520940467d84.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1819":"3e8da3faec380724","7429":"b1cbc98238662b36"}[chunkId] + ".js";
};